import { render, staticRenderFns } from "./right-content.vue?vue&type=template&id=e95390e4&scoped=true"
import script from "./right-content.vue?vue&type=script&lang=js"
export * from "./right-content.vue?vue&type=script&lang=js"
import style0 from "./right-content.vue?vue&type=style&index=0&id=e95390e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95390e4",
  null
  
)

export default component.exports